import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ButtonMover } from './Buttons';
import { i18n } from '../i18n';
import { integration } from '../integration';

const ProductItemBody = styled.div`
	flex: 0 0 16.3vw;
	overflow: hidden;
	text-align: center;
	&::-webkit-scrollbar { width: 0 !important }
	display: flex;
	flex-direction: row;
	background-size: 100% 100%;
	font-size: 4vw;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	white-space: nowrap;
	margin: 1vw 0 0.5;
	line-height: 1.2em;
	color: white;
	box-sizing: border-box;
	padding: 1vw 1vw 2vw;
	background-image: url('/assets/productStore/store_panel_blank_25.png');
	align-items: center;
`
const ProductItemBodyBonus = styled(ProductItemBody)`
	flex: 0 0 19.3vw;
	padding-top: 3vw;
	background-image: url('/assets/productStore/store_panel_blank_25_bonus.png');
`

const WatchItemBody = styled.div`
	flex: 0 0 19.3vw;
	overflow: auto;
	text-align: center;
	color: black;
	&::-webkit-scrollbar { width: 0 !important }
	display: flex;
	flex-direction: row;
	background-size: 100% 100%;

	padding: 4vw;
	margin-bottom: 0.5vw;
`

const WatchButton = styled.div`
	flex: 0 0 27vw;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	flex-direction: row;
	color: white;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	font-size: 4.5vw;
	position:relative;
	margin-left: 4vw;
`

const ProductCol = styled.div`
	display: flex;
	height: 100%;
`

const AllCenter = styled(ProductCol)`
	justify-content: center;
	align-items: center;
`

const LeftCenter = styled(ProductCol)`
	justify-content: center;
	align-items: flex-start;
`

const HeartAmount = styled(AllCenter)`
	flex-basis: 166px;
	flex-direction: column;
	/* background-color: rgba(255,255,255,0.5); */
	font-size: 5.5vw;
	line-height: 5.5vw;
	.hearts {
		font-size: 2.5vw;
		text-transform: uppercase;
		line-height: 2.5vw;
	}
`

const TotalHearts = styled(AllCenter)`
	flex-direction: column;
	flex-basis: 150px;
	text-shadow: none;
	/* background-color: rgba(100,255,255,0.5); */
	color: #703507;
	font-size: 5vw;
	line-height: 5vw;
	.hearts {
		font-size: 3vw;
		text-transform: capitalize;
		line-height: 3vw;
	}
`
const Action = styled(AllCenter)`
	flex-basis: 220px;
	font-size: 4.5vw;
	line-height: 4.5vw;
	/* background-color: rgba(255,255,100,0.5); */
	overflow: hidden;
`

const PriceButton = styled.div`
	background-image: url("/assets/productStore/store_buy_button_blank.png");
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 19.5vw;
	height: 16vw;
	font-size: ${p => 6.5 - (p.price.length / 3)}vw;
`


const ProductName = styled(LeftCenter)`
	flex-basis: 290px;
	/* background-color: rgba(255,100,255,0.5); */
	display: flex;
	box-sizing: border-box;
	padding-left: 1vw;
	flex-direction: column;
`

const BonusPercent = styled(AllCenter)`
	flex-basis: 200px;
	/* background-color: rgba(255,100,100,0.5); */
`

const Name = styled.div`
	color: white;
	font-size: 4vw;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	white-space: nowrap;
	margin-top: 1vw;
	line-height: 1.2em;
`

const Desc = styled.div`
	color: white;
	font-size: 3vw;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	white-space: nowrap;
	line-height: 1.5em;
`

@observer
export class ProductItem extends Component {

	buyProduct(productId, priceStr){
		window.manager.playAudio("poopPop");
		if(productId === 'WATCH_H1') {
			integration.postAnalyticsEvent(`store_watch_ad`, `economy`);
			if(store.enableRewardAds && store.rewardAdIsLoaded) {
				window.manager.playAudio("poopPop");
				if(!(window.location.port === '3000' || window.location.hash === '#dev')) {
					store.rewardAdModalHearts = 0;
					window.WrapperApp.postMessage("show-rewardVideo?name=default");
					store.modal = 'videoDimPanel';
				} else {
					// store.modal = '';
					// store.rewardAdModalHearts = 1;
					// store.modal = 'rewardVideo';
					store.modal = 'videoDimPanel';
					window.manager.processRewardAdClosed();
				}
			}
			// window.manager.showRewardVideoModal();
			// // store.showProductStore = false;
		} else {
			var s = productId.split("_H");
			var heartNumberString = s.length > 0 ? s[1] : '';
			if(heartNumberString !== '') {
				var num = Number(heartNumberString);
				integration.postAnalyticsEvent(`store_purchase_heart_quant_`+num, `economy`);
				integration.postAnalyticsEvent(`store_purchase_heart_amt_`+priceStr, `economy`);
			}
			store.modal = 'dimPanel';
			window.WrapperApp.postMessage("purchase-product?productid="+productId);
		}
	}

	render(){

		var p = store.products[this.props.i];
		var a = p.title.split('(');
		var title = a[0].trim();

		const watchButtonImage = store.rewardAdIsLoaded === true ? "/assets/languages/"+store.settings.language+"/store_btn_level-0.png" : "/assets/languages/"+store.settings.language+"/store_btn_level-0_greyed.png";

		return (
			p.productId === 'WATCH_H1' ?
			(
			<WatchItemBody
				style={{
					backgroundImage: `url('/assets/languages/${store.settings.language}/store_panel_level-0_example_noButton.png')`
				}}
			>
				<WatchButton>
					<ButtonMover onClick={this.buyProduct.bind(this, p.productId, p.price)}>
						<div style={{position: 'relative', top: '1.5vw'}}>
						<img draggable="false"
							style={{width: '30vw', marginLeft: '58vw'}} alt="buy" src={watchButtonImage}/>
						</div>
					</ButtonMover>
				</WatchButton>
			</WatchItemBody>
			) : p.productId === 'HEARTS_1_6_H460' ?
			(
			<ProductItemBodyBonus>
				<HeartAmount>
					{p.heartNumberDiscountedString}
					<div className="hearts">{i18n.t('hearts')}</div>
				</HeartAmount>

				<ProductName>
					<Name>{title}</Name>
					<Desc>{p.description}</Desc>
				</ProductName>

				<BonusPercent/>

				<TotalHearts>
					{p.heartNumberString}
					<div className="hearts">{i18n.t('hearts')}</div>
				</TotalHearts>

				<Action>
					<ButtonMover onClick={this.buyProduct.bind(this, p.productId)}>
						<PriceButton price={p.price} >
							{p.price}
						</PriceButton>
					</ButtonMover>
				</Action>
			</ProductItemBodyBonus>
			) : (
			<ProductItemBody>
				<HeartAmount>
					{p.heartNumberDiscountedString}
					<div className="hearts">{i18n.t('hearts')}</div>
				</HeartAmount>

				<ProductName>
					<Name>{title}</Name>
					<Desc>{p.description}</Desc>
				</ProductName>

				<BonusPercent/>

				<TotalHearts>
					{p.heartNumberString}
					<div className="hearts">{i18n.t('hearts')}</div>
				</TotalHearts>

				<Action>
					<ButtonMover onClick={this.buyProduct.bind(this, p.productId)}>
						<PriceButton price={p.price}>
							{p.price}
						</PriceButton>
					</ButtonMover>
				</Action>
			</ProductItemBody>
			)
		)
	}
}
